import type { BrandingConfig } from '@axsolutionsdev/core-fe';

const EGM_LOGO = '/branding/egm-logo.png';
const EGM_LOGIN_BG = '/branding/egm-login-bg.jpg';

export const egmBranding: Partial<BrandingConfig> = {
  productName: 'EGM MES',
  title: 'EGM MES',
  companyName: '',
  copyrightText: '© 2026 EGM Corp',
  logo: {
    light: EGM_LOGO,
    dark: EGM_LOGO,
    favicon: EGM_LOGO,
    loginBackground: EGM_LOGIN_BG,
  },
};
